import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      clipPath="url(#a)"
    >
      <path d="M2.062 2.456a.79.79 0 0 0-.787.788v6.694a.79.79 0 0 0 .787.787h7.875a.79.79 0 0 0 .788-.787V3.244a.787.787 0 0 0-.788-.788zM1.275 5.213h9.45M3.244 1.275v2.363M8.756 1.275v2.363" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStreamlineCalendar;
